<template>
  <div>
    <DialogSeeAttachment :attached_file_url="attached_file_url" :dialog="attach_dialog"></DialogSeeAttachment>
    <dialog-loading loadingText="Deletando..." v-if="deleting"></dialog-loading>
    <dialog-one-envelope :envelope_id="envelope_id" @closeDialog="handleCloseDialog" @doneDelete='handleDoneDelete' @doneConfirm="handleDoneConfirm"></dialog-one-envelope>
    <v-card class="elevation-0">
      <v-card-text >
        <date-search v-if="with_date_search" @onDateSearch="handleDateSearch"></date-search>
        <v-data-table
          :headers="comp_headers"
          :items="loading? [] : items"
          class="elevation-0"
          :search="tableSearch"
          ref='table'
          :loading='loading'
          mobile-breakpoint="1"
        >
          <template v-slot:top>
            <v-row justify="center" class="my-2">
              <v-col cols='5'>
                <v-card style="border-radius:12px">
                  <v-card-text class="px-2 py-1">
                    <v-row align="center" class="px-5 py-2" justify="center">
                        <v-icon x-large class="mr-5" color='blue-grey darken-3'>mdi-currency-usd</v-icon>
                        <span class="title">{{ total_value_sum.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols='5'>
                <v-card style="border-radius:12px">
                  <v-card-text class="px-2 py-1">
                    <v-row align="center" class="px-5 py-2" justify="center">
                        <v-icon x-large class="mr-5" color='blue-grey darken-3'>mdi-email-outline</v-icon>
                        <span class="title">{{ total_envelopes }} envelopes</span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>
          
          <template v-slot:item.attributes.created_at="{item}">
            <span>
              {{$moment(item.attributes.created_at.substring(0,10)+'T'+item.attributes.created_at.substring(11,19)).subtract(3,'hour').format('L, HH:mm')}}
            </span>
          </template>

          <template v-slot:item.attributes.total_value="{item}">
            {{Number(item.attributes.total_value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
          </template>
          <template v-slot:item.attributes.total_in_cash="{item}">
            {{Number(item.attributes.total_in_cash).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
          </template>
          <template v-slot:item.attributes.total_in_checks="{item}">
            {{Number(item.attributes.total_in_checks).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
          </template>
          <template v-slot:item.attachement="{item}">
            <div class="d-flex align-center justify-center">
              <div v-if="item.attributes.attached_file_url">
                <v-btn @click="openFileAttach(item.attributes.attached_file_url)" icon>
                  <v-icon :color="item.attributes.checks_count == 0 ? 'success':'primary'">mdi-paperclip</v-icon>
                </v-btn>
              </div>
              <div v-else>
                <FileInput :color="item.attributes.checks_count == 0 ? 'green-color':'red-color'" @done="handleDone" hide_input :wait_input="false" :update_infos="{MODEL: 'Envelope', id: parseInt(item.id)}"></FileInput>
              </div>
            </div>
          </template>
          
          <template v-slot:item.attributes.comment="{item}">
            <v-btn color="red" dark @click="seeComment(item.attributes.comment)" small icon> <v-icon>mdi-chat</v-icon> </v-btn>
          </template>

          <template v-slot:item.attributes.action="{item}">
            <div class="d-flex align-center">
              <v-btn color="primary" x-small @click="editItem(item)" > abrir </v-btn>
              <v-tooltip bottom v-if="isDirector() && !item.attributes.was_received">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="deletePayment(item)" v-bind="attrs" v-on="on" x-small outlined fab class="ml-1 mr-2" color="error">
                    <v-icon>mdi-trash-can</v-icon>
                  </v-btn>
                </template>
                <span>Excluir pagamento</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="comment_dialog" v-if="comment_dialog" max-width="500px" transition="dialog-transition" >
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Comentário</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5">
          {{ comment }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/index';
export default {
  name: "EnvelopesTable",
  components: {
    DateSearch: () => import('@/_backoffice/_financial/components/shared/DateSearch.vue'),
    DialogOneEnvelope: () => import('./DialogOneEnvelope'),
    DialogSeeAttachment: () => import('@/components/shared/DialogSeeAttachment.vue'),
    FileInput: () => import('@/components/shared/FileInput.vue'),
  },
  props: {
    items: {
      type: Array,
    },
    headers:{
      type: Array,
    },
    title:{
      type: String,
    },
    with_date_search: {
      type: Boolean,
      default: false
    },
    tableSearch: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      deleting: false,
      headers_default: [
        { text: 'Criado em', value: 'attributes.created_at' },
        { text: 'Criado por', value: 'attributes.creator_name' },
        { text: 'Módulo', value: 'attributes.place_name' },
        { text: 'Código', value: 'attributes.code' },
        { text: 'Qtd Pgto', value: 'attributes.total_payments' },
        { text: 'Valor total (R$)', value: 'attributes.total_value' },
        { text: 'Total em dinheiro (R$)', value: 'attributes.total_in_cash' },
        { text: 'Total em cheque (R$)', value: 'attributes.total_in_checks' },
        { text: 'Qtd cheques', value: 'attributes.checks_count' },
        { text: 'Anexo', value: 'attachement' },
        { text: 'Comentário', value: 'attributes.comment' },
        { text: 'Ação', value: 'attributes.action' },
      ],
      
      comment: '',
      comment_dialog: false,
      attach_dialog: false,
      envelope_id: null,
      attached_file_url: null,
    }
  },

  computed: {
    comp_headers(){
      return this.headers || this.headers_default
    },
    total_value_sum() {
      if (this.tableSearch && this.$refs.table){
        return this.loading? 0 : this.$refs.table.internalCurrentItems.reduce((acc, one)=> acc + Number(one.attributes.total_value) ,0)
      }
      return this.loading? 0 : this.items.reduce((acc, one)=> acc + Number(one.attributes.total_value) ,0)
    },

    total_envelopes() {
      if (this.tableSearch && this.$refs.table){
        return this.loading? 0 : this.$refs.table.internalCurrentItems.length
      }
      return this.loading? 0 : this.items.length
    }
  },

  methods: {
    isPdf(url) {
      const path = String(url || '').split('?')[0].split('#')[0]
      return path.toLowerCase().endsWith('.pdf')
    },
    openFileAttach(attached_file_url){
      if (this.isPdf(attached_file_url)) {
        window.open(attached_file_url, '_blank', 'noopener')
        return
      }
      this.attached_file_url = attached_file_url
      this.attach_dialog = !this.attach_dialog
    },
    deletePayment(item){
      this.swallConfirmation({
          title: 'Deseja EXCLUIR o pagamento?',
          icon: 'warning',
        }).then( confirmed =>{
          if (confirmed ) {
            this.deleting = true
            Api.Envelope.delete(item.id).then(res => {
              this.successDeleted()
            }).catch(err => {
              this.errorUpdated()
            }).finally(()=>{
              this.deleting = false
              this.$emit('doneDelete')
            })
          }
        })     
    },
    handleDoneDelete(){
      this.envelope_id = null
      this.$emit('doneDelete')
    },
    handleDoneConfirm(){
      this.envelope_id = null
      this.$emit('doneConfirm')
    },
    handleDone(){
      this.envelope_id = null
      this.$emit('done')
    },
    editItem(item){
      this.envelope_id = null
      this.envelope_id = item.id
    },
    handleCloseDialog(e){
      this.envelope_id = null
    },
    seeComment(comment) {
      this.comment = comment
      this.comment_dialog = true
    },
    handleDateSearch(e){
      this.$emit('dateSearched', e)
    }
  },
}
</script>
